import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Table, Dropdown, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../store/AuthContext';
import { backendURL } from '../IPaddress';
import '../CSS/CRUDfiles.css';
import Select from '../store/ThemedSelect';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useSchoolYear } from '../store/SchoolYearCalculator';
import ErrorModalMessage from '../store/ErrorMessage';
import {
  FilterBar,
  SearchInput,
  SortControl,
  ResultSummary,
  useListControls,
} from '../components/crud';

const WorkshopStudentsOBC = () => {
    // OBC Workshop Students event type; differs per env (prod=12, dev=14).
    // Defaults to the prod value; override with REACT_APP_OBC_WORKSHOP_STUDENTS_EVENT_TYPE_ID for local dev.
    const live = Number(process.env.REACT_APP_OBC_WORKSHOP_STUDENTS_EVENT_TYPE_ID) || 12;
    const [eventsPrograms, setEventsPrograms] = useState([]);
    const [currentEventProgram, setCurrentEventProgram] = useState({
      event_template_id: null,
      name: null,
      description: '',
      location_id: null,
      coordinator_id: null,
      event_type_id: live,
      student_performance: false
    });
    const [currentEventDate, setCurrentEventDate] = useState({
      event_dates_id: null,
      event_id: null, 
      date: null,
      start_time: null, 
      end_time: null,
      total_seats: null,
      sold_out: false,
    });
    const [dateSchools, setDateSchools] = useState([{ school_id: null, number_of_students: null }]);
    const [eventDates, setEventDates] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [showModalDateEvent, setShowModalDateEvent] = useState(false);
    const { authState } = useAuth();
    const [openStates, setOpenStates] = useState({});
    const navigate = useNavigate();
    const [eventTypes, setEventTypes] = useState([]);
    const [locations, setLocations] = useState([]);
    const [userNames, setUsersNames] = useState([]);
    const [newDateModal, setNewDateModal] = useState(false);
    const [showEventDateModal, setShowEventDateModal] = useState(false);
    const [showDeletionError, setShowDeletionError] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [profileEvents, setProfileEvents] = useState([]);
    const [obcWorkshopTypes, setOBCWorkshopTypes] = useState([]);
    const [teacherProfiles, setTeacherProfiles] = useState([]);
    const [selectedTeachers, setSelectedTeachers] = useState([]);
    const [selectedTeacher, setSelectedTeacher] = useState([]);
    const [displayedSelectionTeachers, setDisplayedSelectionTeachers] = useState([]);
    const [schoolYearList, setSchoolYearList] = useState([]);
    const [selectedSchoolYear, setSelectedSchoolYear] = useState();
    const { currentYear, schoolYearListParent } = useSchoolYear();
    const [selectedSchool, setSelectedSchool] = useState([]);
    const [selectedSchools, setSelectedSchools] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [schools, setSchools] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [datesSchools, setDatesSchools] = useState([]);
    const [itemsToDelete, setItemsToDelete] = useState([]);

    useEffect(() => {
      if (!authState) {
        navigate('/login');
      }
    }, [authState, navigate]);

    useEffect(() => {
      if (currentYear && schoolYearListParent.length) {
        setSelectedSchoolYear(currentYear);
        setSchoolYearList(schoolYearListParent);
      }
    }, [currentYear, schoolYearListParent]);

    useEffect(() => {
      if (selectedSchoolYear) {
        fetchEventsPrograms();
        fetchEventDates();
        fetchProfileEvents();
        fetchDatesSchool();
      }
    }, [selectedSchoolYear]);
  
    useEffect(() => {
      fetchEventTypes();
      fetchLocations();
      fetchUserNames();
      fetchOBCWorkshopTypes();
      fetchProfiles();
      fetchSchools();
      fetchDistricts();
    }, []);
  
    const fetchEventsPrograms = async () => {
      try {
        const response = await fetch(`${backendURL}/api/events-programs/year/${selectedSchoolYear}`, {
          method: 'GET',
        });
        const data = await response.json();
        const filteredEvents = data.filter(event => event.event_type_id === live);
        setEventsPrograms(filteredEvents);
      } catch {
        ErrorModalMessage('unable to fetch the program events');
      }
    };

    const fetchProfiles = async () => {
      const response = await fetch(`${backendURL}/api/profiles`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!response) {
        console.error('failed to fetch profiles');
      };
      const data = await response.json();
      setTeacherProfiles(data);
    }

    const fetchDatesSchool = async () => {
      const response = await fetch(`${backendURL}/api/dates-schools/year/${selectedSchoolYear}`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!response) {
        console.error('failed to fetch dates schools links');
      };
      const data = await response.json();
      setDatesSchools(data);
    }

    const fetchProfileEvents = async () => {
      const response = await fetch(`${backendURL}/api/profile-events/year/${selectedSchoolYear}`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!response) {
        console.error('failed to fetch profile events');
      }
      const data = await response.json();
      setProfileEvents(data);
    };

    const fetchOBCWorkshopTypes = async () => {
      const response = await fetch(`${backendURL}/api/workshop_types`, {
        method: 'GET',
        credentials: 'include'
      });
      if (!response) {
        console.error('failed to fetch the obc workshop types');
      }
      const data = await response.json();
      setOBCWorkshopTypes(data);
    };
  
    const fetchEventTypes = async () => {
      const response = await fetch(`${backendURL}/api/event-types`, {
        method: 'GET',
        credentials: 'include'
      });
      try {
        const data = await response.json();
        setEventTypes(data);
      } catch (error) {
        console.error("Error fetching the event types: ", error.message);
      }
    };

    const fetchUserNames = async () => {
      try {
        const response = await fetch(`${backendURL}/api/app-users`, {
          method: 'GET',
          credentials: 'include'
        });
        const data = await response.json();
        if (!response.ok) throw new Error('Failed to fetch user data');
        setUsersNames(data);
      } catch (err) {
        console.error(err.message);
      }
    };

    const fetchLocations = async () => {
      const response = await fetch(`${backendURL}/api/locations`, {
        method: 'GET',
        credentials: 'include'
      });
      try {
        const data = await response.json();
        setLocations(data);
      } catch (error) {
        console.error("Error fetching locations: ", error.message);
      }
    };
  
    const fetchEventDates = async () => {
      try {
        const response = await fetch(`${backendURL}/api/event-dates/year/${selectedSchoolYear}`, {
          method: 'GET',
          credentials: 'include'
        });
        const data = await response.json();
        const sortedData = data.sort((a, b) => new Date(a.date) - new Date(b.date));
        setEventDates(sortedData);
      } catch (error) {
        console.error("Error fetching event dates: ", error.message);
      }
    };

    const fetchSchools = async () => {
      const response = await fetch(`${backendURL}/api/schools`);
      if (!response.ok) {
        setErrorMessage('Unable to retrieve school information');
      }
      const data = await response.json();
      if (Array.isArray(data)) {
        setSchools(data);
      } else {
        setErrorMessage('Fetched Schools data is not an array:', data);
      }
    };

    const fetchDistricts = async () => {
      const url = `${backendURL}/api/districts`;
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        setDistricts(data);
      } else {
        setErrorMessage('Unable to retrieve districts');
      }
    };
  
    const handleEventFormChange = (field, value, type = null) => {
      switch(type){

        case null:
          setCurrentEventProgram({
            ...currentEventProgram,
            [field]: value,
            school_year_id: parseInt(selectedSchoolYear, 10)
          });
          break;
        case 'check':
          setCurrentEventProgram({
            ...currentEventProgram,
            [field]: value.target.checked,
            school_year_id: parseInt(selectedSchoolYear, 10)
          });
          break;
        default:
          break;
      }
    };

    const handleTeacherChange = selectedOptions => {
      setSelectedTeachers(selectedOptions);
      const teacherIds = selectedOptions.map(option => parseInt(option.value, 10)).filter(id => !isNaN(id));
      setSelectedTeacher(teacherIds);
    };
  
    const handleEventDateFormChange = (event) => {
      const { name, type, checked, value } = event.target;
  
      if (type === "checkbox") {
        setCurrentEventDate(prevState => ({
          ...prevState,
          [name]: checked,
          school_year_id: parseInt(selectedSchoolYear, 10),
        }));
      } else if (type === "number") {
        setCurrentEventDate(prevState => ({
          ...prevState,
          [name]: parseInt(value, 10),
          school_year_id: parseInt(selectedSchoolYear, 10),
        }));
      } else {
        setCurrentEventDate(prevState => ({
          ...prevState,
          [name]: value,
          school_year_id: parseInt(selectedSchoolYear, 10),
        }));
      }
    };

    const handleDateSchoolFormChange = (index, field, value) => {
      const newDateSchools = [...dateSchools];
      newDateSchools[index][field] = value;
      setDateSchools(newDateSchools);
    }

    const addDateSchool = () => {
      setDateSchools([...dateSchools, { school_id: null, number_of_students: null }]);
    }

    const removeDateSchool = (index) => {
      const newDateSchools = [...dateSchools];
      newDateSchools.splice(index, 1);
      setDateSchools(newDateSchools);
    };

    // Pull a human-readable message out of a failed fetch Response (backend sends {detail} or {error}).
    const getResponseError = async (response) => {
      try {
        const data = await response.json();
        return data.detail || data.error || `HTTP ${response.status}`;
      } catch {
        return `HTTP ${response.status}${response.statusText ? ' ' + response.statusText : ''}`;
      }
    };
    
  
    const handleEventSubmit = async (e) => {
      e.preventDefault();
      const method = currentEventProgram.event_id ? 'PUT' : 'POST';
      const url = currentEventProgram.event_id ? `${backendURL}/api/events-programs/${currentEventProgram.event_id}` : `${backendURL}/api/events-programs`;
      await fetch(url, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(currentEventProgram),
        credentials: 'include',
      });
  
      setCurrentEventProgram({
        event_template_id: null,
        name: null,
        description: '',
        location_id: null,
        coordinator_id: null,
        event_type_id: live,
        student_performance: false
      });
      setShowForm(false);
      fetchEventsPrograms();
    };
  
    const handleNewEventDate = async (eventProgramId) => {
      setCurrentEventDate({
        event_dates_id: null,
        event_id: eventProgramId, 
        date: null, 
        start_time: null, 
        end_time: null,
        total_seats: null,
        sold_out: false,
      });
      setDateSchools([{ school_id: null, number_of_students: null }]);
      setShowEventDateModal(true);
    };

    const handleMarkForDeletion = (index) => {
      const itemToDelete = dateSchools[index];
      setItemsToDelete([...itemsToDelete, itemToDelete]);
      removeDateSchool(index); // Optionally, you can immediately remove the item from the list displayed in the form
    };
    
  
    const handleEventDateSubmit = async (e) => {
      e.preventDefault();
      try {
        const method = currentEventDate.event_dates_id ? 'PUT' : 'POST';
        const url = currentEventDate.event_dates_id ? `${backendURL}/api/event-dates/${currentEventDate.event_dates_id}` : `${backendURL}/api/event-dates`;
        const dateResponse = await fetch(url, {
          method: method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(currentEventDate),
          credentials: 'include',
        });
        if (!dateResponse.ok) {
          throw new Error(`Failed to save the event date: ${await getResponseError(dateResponse)}`);
        }
        const newDateResponse = await dateResponse.json();
    
        if (newDateResponse && newDateResponse.event_dates_id) {
          // Only save rows that actually have a school selected (school_id is stored as [id]).
          const payloadDatesSchools = dateSchools
            .map(ds => ({
              ...ds,
              normalized_school_id: Array.isArray(ds.school_id) ? ds.school_id[0] : ds.school_id,
            }))
            .filter(ds => ds.normalized_school_id != null && ds.normalized_school_id !== '')
            .map(ds => ({
              event_date_id: newDateResponse.event_dates_id,
              school_id: ds.normalized_school_id,
              number_of_students: parseInt(ds.number_of_students, 10) || 0,
              school_year_id: parseInt(selectedSchoolYear, 10),
            }));

          const schoolResponses = await Promise.all(payloadDatesSchools.map(payload =>
            fetch(`${backendURL}/api/dates-schools/${newDateResponse.event_dates_id}/${payload.school_id}`, {
              method: method,
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload),
              credentials: 'include'
            })
          ));
          const failedSchools = schoolResponses.filter(r => !r.ok);
          if (failedSchools.length) {
            const detail = await getResponseError(failedSchools[0]);
            setErrorMessage(`Failed to save ${failedSchools.length} of ${schoolResponses.length} school(s) on this date: ${detail}`);
          }
    
          const deletePromises = itemsToDelete.map(item => {
            const deleteUrl = `${backendURL}/api/dates-schools/${newDateResponse.event_dates_id}/${item.school_id}`;
            return fetch(deleteUrl, {
              method: 'DELETE',
              credentials: 'include'
            });
          });
    
          await Promise.all(deletePromises);
    
          const eventProfileUrl = currentEventDate.event_dates_id ? `${backendURL}/api/profile-events/${currentEventDate.event_dates_id}` : `${backendURL}/api/profile-events`;
          const payload = {
            event_id: newDateResponse.event_dates_id,
            profile_id: selectedTeacher,
            school_year_id: parseInt(selectedSchoolYear, 10),
          };
          const eventProfileResponse = await fetch(eventProfileUrl, {
            method: method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            credentials: 'include'
          });
          if (!eventProfileResponse.ok) {
            setErrorMessage(`Failed to link teachers to the date: ${await getResponseError(eventProfileResponse)}`);
          }
        }
    
        setCurrentEventDate({
          event_dates_id: null,
          event_id: null,
          date: null,
          start_time: null,
          end_time: null,
          total_seats: null,
          sold_out: false,
        });
        setDateSchools([{ school_id: null, number_of_students: null }]);
        setShowEventDateModal(false);
        setShowModalDateEvent(false);
        setNewDateModal(false);
        fetchEventDates();
        fetchDatesSchool();
        setSelectedSchool([]);
        setSelectedSchools([]);
        fetchProfileEvents();
        setSelectedTeachers([]);
        setSelectedTeacher([]);
        setItemsToDelete([]); // Clear the items to delete list after successful submission
      } catch (err) {
        setErrorMessage(`Unable to save the date: ${err?.message || 'unexpected error'}`);
      }
    };
    
    
    
    
  
    const editEventProgram = (eventProgram) => {
      setCurrentEventProgram(eventProgram);
      setShowForm(true);
    };

    const teacherOptions = teacherProfiles.map(teacherProfile => ({
      label: `${teacherProfile.first_name} ${teacherProfile.last_name}`,
      value: teacherProfile.profile_id
    }));

    const schoolOptions = schools.map(school_id => {
      const district = districts.find(d => d.district_id === school_id.district_id);
      const districtName = district ? district.name : 'Unknown District';
      return {
        label: `${school_id.name} (${districtName})`,
        value: school_id.school_id
      };
    });

    const getTeachersForDate = (eventDateId) => {
      const eventDateObjs = eventDates.filter(eventDate => eventDate.event_id === eventDateId);
      if (eventDateObjs.length > 0) {
        const eventDatesIds = eventDateObjs.map(eventDate => eventDate.event_dates_id);
        const profileEventObjs = profileEvents.filter(profileEvent => eventDatesIds.includes(profileEvent.event_id));
        if (profileEventObjs.length > 0) {
          const profileIds = profileEventObjs.flatMap(profileEvent => profileEvent.profile_id);
          const listOfTeachers = teacherProfiles.filter(teacher => profileIds.includes(teacher.profile_id));
          return (
            <ul>
              {listOfTeachers.map(teacher => <li key={teacher.profile_id}>{teacher.first_name} {teacher.last_name}</li>)}
            </ul>
          );
        } else {
          return <p>No Teachers assigned to dates.</p>;
        }
      } else {
        return <p>No dates found.</p>;
      }
    };
  
    const editEventDate = (eventDate) => {
      const eventDateTeachersObj = profileEvents.filter(
        eventProfile => eventProfile.event_id === eventDate.event_dates_id
      );
    
      const datesSchoolsObjs = datesSchools.filter(
        dateSchool => dateSchool.event_date_id === eventDate.event_dates_id
      );
    
      const listOfTeachers = eventDateTeachersObj.flatMap(eventProfile =>
        teacherOptions.filter(teacherOption => eventProfile.profile_id.includes(teacherOption.value))
      );
    
      if (listOfTeachers.length) {
        const teacherIds = listOfTeachers.map(option => parseInt(option.value, 10)).filter(id => !isNaN(id));
        setSelectedTeachers(listOfTeachers);
        setSelectedTeacher(teacherIds);
      } else {
        setSelectedTeachers([]);
        setSelectedTeacher([]);
      }
    
      const listOfSchools = datesSchoolsObjs.flatMap(eventDateSchool =>
        schoolOptions.filter(schoolOption => eventDateSchool.school_id === schoolOption.value)
      );
      if (listOfSchools.length) {
        const schoolIds = listOfSchools.map(option => parseInt(option.value, 10)).filter(id => !isNaN(id));

        setSelectedSchools(listOfSchools);
        setSelectedSchool(schoolIds);
      } else {
        setSelectedSchool([]);
        setSelectedSchools([]);
      }
    
      setCurrentEventDate({ ...eventDate });
      setDateSchools(datesSchoolsObjs.map(ds => ({
        school_id: ds.school_id,
        number_of_students: ds.number_of_students
      })));
      setShowEventDateModal(true);
    };
    
  
    const handleCancel = () => {
      setCurrentEventDate({
        event_dates_id: null,
        event_id: null, 
        date: null,
        start_time: null, 
        end_time: null,
        total_seats: null,
        sold_out: false,
      });
      setCurrentEventProgram({
        event_template_id: null,
        name: null,
        description: '',
        location_id: null,
        coordinator_id: null,
        event_type_id: live,
        student_performance: false
      });
      setDateSchools([{ school_id: null, number_of_students: null }]);
      setSelectedSchool([]);
      setSelectedSchools([]);
      setShowForm(false);
      setShowEventDateModal(false);
      setShowModalDateEvent(false);
      setNewDateModal(false);
      setSelectedTeachers([]);
      setSelectedTeacher([]);
      setItemsToDelete([]);
    };
    
  
    const handleShowForm = () => {
      setCurrentEventProgram({
        event_template_id: null,
        name: null,
        description: '',
        location_id: null,
        coordinator_id: null,
        event_type_id: live,
        student_performance: false
      });
      setShowForm(!showForm);
    };
  
    const deleteEventProgram = async (event_id) => {
      try {
        const response = await fetch(`${backendURL}/api/events-programs/${event_id}`, {
          method: 'DELETE',
          credentials: 'include',
        });
        if (response.ok) {
          fetchEventsPrograms();
          fetchEventDates();
          fetchDatesSchool();
          fetchProfileEvents();
        } else {
          setErrorMessage(`Unable to delete the workshop: ${await getResponseError(response)}`);
        }
      } catch (error) {
        setErrorMessage(`Error deleting the workshop: ${error?.message || 'unexpected error'}`);
      }
      setSelectedTeacher([]);
    };
  
    const handleDeleteEventDate = () => {
      setConfirmationMessage('Are you sure you want to delete this event date?')
      setShowConfirmationModal(true);
    }
    
    const deleteEventDate = async (eventDateId) => {
      try {
        const deleteDateSchool = await fetch(`${backendURL}/api/dates-schools/${eventDateId}`, {
          method: 'DELETE',
          credentials: 'include',
        });        
        if (deleteDateSchool.ok) {
          const response = await fetch(`${backendURL}/api/event-dates/${eventDateId}`, {
            method: 'DELETE',
            credentials: 'include'
          });
          if (response.ok) {
            setShowEventDateModal(false);
            setShowConfirmationModal(false);
            setSelectedTeachers([]);
            setSelectedTeacher([]);
            fetchProfileEvents();
            fetchEventDates();
            fetchDatesSchool();
          } else {
            throw new Error(`Failed to delete the date: ${await getResponseError(response)}`);
          }
        } else {
          throw new Error(`Failed to remove the date's schools: ${await getResponseError(deleteDateSchool)}`);
        }
      } catch (error) {
        setErrorMessage(`Could not delete the date: ${error?.message || 'unexpected error'}`);
      }
    };
  
    const formatTime = (timeString) => {
      if (timeString === null) {
        return `no time set`;
      }
      const [hours, minutes] = timeString.split(':');
      const hoursInt = parseInt(hours, 10);
      const suffix = hoursInt >= 12 ? 'PM' : 'AM';
      const formattedHours = ((hoursInt + 11) % 12 + 1); // Convert 24hr to 12hr format
      return `${formattedHours}:${minutes} ${suffix}`;
    };
  
    const getProgramEventDates = (eventId) =>
      eventDates
        .filter(eventDate => eventDate.event_id === eventId)
        .sort((a, b) => new Date(a.date) - new Date(b.date));

    const getDateSchoolLinksForDate = (eventDateId) =>
      datesSchools.filter(dateSchool => dateSchool.event_date_id === eventDateId);

    const getSchoolCountForProgram = (eventId) => {
      const dateIds = getProgramEventDates(eventId).map(d => d.event_dates_id);
      const schoolIds = new Set();
      datesSchools
        .filter(ds => dateIds.includes(ds.event_date_id))
        .forEach(ds => schoolIds.add(ds.school_id));
      return schoolIds.size;
    };

    const getStudentTotalForProgram = (eventId) =>
      getProgramEventDates(eventId)
        .flatMap(d => getDateSchoolLinksForDate(d.event_dates_id))
        .reduce((total, ds) => total + (parseInt(ds.number_of_students, 10) || 0), 0);

    const getTeacherCountForProgram = (eventId) => {
      const dateIds = getProgramEventDates(eventId).map(d => d.event_dates_id);
      const profileIds = new Set();
      profileEvents
        .filter(pe => dateIds.includes(pe.event_id))
        .forEach(pe => [].concat(pe.profile_id).forEach(id => profileIds.add(id)));
      return profileIds.size;
    };

    const getProgramScheduleSummary = (eventId) => {
      const programDates = getProgramEventDates(eventId);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const upcoming = programDates.find(d => d.date && new Date(d.date) >= today);
      const latest = programDates.length ? programDates[programDates.length - 1] : null;
      return {
        dateCount: programDates.length,
        nextDate: upcoming?.date || 'No upcoming dates',
        latestDate: latest?.date || 'No dates added',
        schoolCount: getSchoolCountForProgram(eventId),
        studentTotal: getStudentTotalForProgram(eventId),
        teacherCount: getTeacherCountForProgram(eventId),
      };
    };

    const renderEventDates = (eventProgram) => {
      const programDates = getProgramEventDates(eventProgram.event_id);
      if (programDates.length === 0) {
        return (
          <div className="schedule-empty-state">
            No dates have been created for this workshop yet.
          </div>
        );
      }
      return (
        <div className="schedule-card-grid">
          {programDates.map(eventDate => {
            const linkedSchools = getDateSchoolLinksForDate(eventDate.event_dates_id);
            const totalStudents = linkedSchools.reduce(
              (total, link) => total + (parseInt(link.number_of_students, 10) || 0),
              0
            );
            const schoolPreview = linkedSchools
              .slice(0, 3)
              .map(link => getSchoolName(link.school_id))
              .join(', ');
            return (
              <button
                type="button"
                key={eventDate.event_dates_id}
                className="schedule-card"
                onClick={() => editEventDate(eventDate)}
              >
                <div className="schedule-card-header">
                  <span className="schedule-card-title">{eventDate.date || 'No date set'}</span>
                </div>
                <div className="schedule-card-time">
                  {`${formatTime(eventDate.start_time)} to ${formatTime(eventDate.end_time)}`}
                </div>
                <div className="schedule-card-meta">
                  {`${linkedSchools.length} school${linkedSchools.length === 1 ? '' : 's'}, ${totalStudents} students`}
                </div>
                <div className="schedule-card-preview">
                  {schoolPreview || 'No school counts added yet'}
                  {linkedSchools.length > 3 ? '…' : ''}
                </div>
              </button>
            );
          })}
        </div>
      );
    };

    const getSchoolName = (schoolId) => {
      const schoolObj = schoolOptions.find(school => school.value === schoolId);
      return schoolObj ? schoolObj.label : 'School name failed to load';
    };

    const getLocation = (locationId) => {
      const location = locations.find(loc => loc.location_id === locationId);
      return location ? location.name : 'No location set';
    };
  
    const getSchoolObj = (eventId) => {
      // Filter eventDates to get the matching eventDateObj
      const eventDateObj = eventDates.filter(date => date.event_id === eventId);
    
      // Filter datesSchools to get the list of schools based on matching event_date_id
      const listOfSchools = datesSchools.filter(dateSchool => 
          eventDateObj.some(eventDate => dateSchool.event_date_id === eventDate.event_dates_id)
      );
    
      // Use a Set to track unique school IDs
      const uniqueSchoolIds = new Set();
    
      // Collect unique schools
      const uniqueSchools = [];
      listOfSchools.forEach(dateSchool => {
          if (!uniqueSchoolIds.has(dateSchool.school_id)) {
              uniqueSchoolIds.add(dateSchool.school_id);
              uniqueSchools.push(dateSchool.school_id);
          }
      });
    
      return (
          <>
              {uniqueSchools.map(schoolId => 
                  <li key={schoolId}>{getSchoolName(schoolId)}</li>
              )}
          </>
      );
    };
    

    const toggleOpenState = (eventId) => {
      setOpenStates(prevOpenStates => ({
        ...prevOpenStates,
        [eventId]: !prevOpenStates[eventId],
      }));
    };

    const handleYearChange = (event) => {
      setSelectedSchoolYear(event.target.value);
    };

    const {
      items: visibleEventsPrograms,
      resultCount,
      totalCount,
      isFiltered,
      search,
      sort,
      clear,
    } = useListControls(eventsPrograms, {
      searchAccessor: (eventProgram) =>
        [eventProgram.name, eventProgram.description].filter(Boolean).join(' '),
      sortOptions: [
        {
          key: 'name',
          label: 'Name',
          accessor: (eventProgram) => eventProgram.name?.toLowerCase() ?? '',
        },
        {
          key: 'location',
          label: 'Location',
          accessor: (eventProgram, ctx) =>
            ctx.getLocation(eventProgram.location_id)?.toLowerCase() ?? '',
        },
      ],
      context: { getLocation },
    });

    return (
      <div>
        <Button onClick={() => handleShowForm()} className="m-1">
          {showForm ? 'Show OBC Workshops List' : 'Add New Workshop'}
        </Button>
        <div>
          <Dropdown>
            <span className='fw-bold'>Select School Year</span>
            <select value={selectedSchoolYear} onChange={handleYearChange}>
              <option value="" disabled>Select School Year</option>
              {schoolYearList.map((year) => (
                <option key={year.id} value={year.id}>
                  {year.school_year}
                </option>
              ))}
            </select>
          </Dropdown>
        </div>
        {showForm ? (
          <Form onSubmit={handleEventSubmit}>
            <Form.Group controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter event name"
                name="name"
                value={currentEventProgram.name}
                onChange={e => handleEventFormChange('name', e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="description">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter event description"
                name="description"
                value={currentEventProgram.description}
                onChange={e => handleEventFormChange('description', e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId='student_performance'>
              <Form.Label>Is this a student performance?</Form.Label>
              <Form.Check
              checked={currentEventProgram.student_performance}
              onChange={e => handleEventFormChange('student_performance', e, 'check')}
              name='student_performance'
              ></Form.Check>
            </Form.Group>
            <Form.Group controlId="location_id">
              <Form.Label>Location ID</Form.Label>
              <Form.Control
                as={'select'}
                name="location_id"
                value={currentEventProgram.location_id}
                onChange={e => handleEventFormChange('location_id', e.target.value)}
              >
                <option value={null}>{"Select Location"}</option>
                {locations.map(location => (
                  <option key={location.location_id} value={location.location_id}>{location.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
            <Button type="submit" className="m-1">Submit</Button>
            <Button variant="secondary" className="m-1" onClick={handleCancel}>Cancel</Button>
          </Form>
        ) : (
          <>
            <FilterBar
              summary={(
                <ResultSummary
                  count={resultCount}
                  total={totalCount}
                  noun="workshop"
                  onClear={clear}
                  isFiltered={isFiltered}
                />
              )}
            >
              <SearchInput
                label="Search Workshops"
                placeholder="Search by workshop name or description"
                {...search}
              />
              <SortControl {...sort} />
            </FilterBar>

            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Student Workshops</th>
                </tr>
              </thead>
              <tbody>
                {visibleEventsPrograms.length === 0 ? (
                  <tr>
                    <td>
                      <div className="schedule-empty-state">
                        No student workshops match the current filters.
                      </div>
                    </td>
                  </tr>
                ) : visibleEventsPrograms.map(eventProgram => {
                  const isOpen = openStates[eventProgram.event_id] || false;
                  const summary = getProgramScheduleSummary(eventProgram.event_id);
                  const rowDateSummary =
                    summary.dateCount === 0
                      ? 'No dates added'
                      : summary.nextDate !== 'No upcoming dates'
                        ? `Next: ${summary.nextDate}`
                        : `Most recent: ${summary.latestDate}`;

                  return (
                    <React.Fragment key={eventProgram.event_id}>
                      <tr
                        className={`compact-row${isOpen ? ' is-open' : ''}`}
                        onClick={() => toggleOpenState(eventProgram.event_id)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td colSpan={1}>
                          <div className="event-program-row-content">
                            <div className="event-program-main">
                              <div className="event-program-name">{eventProgram.name || 'Untitled workshop'}</div>
                              <div className="event-program-type">OBC Student Workshop</div>
                              <div className="event-program-description">
                                {eventProgram.description || 'No description provided.'}
                              </div>
                            </div>

                            <div className="event-program-row-meta">
                              <span className="compact-pill">{getLocation(eventProgram.location_id)}</span>
                              <span className="compact-pill">{summary.dateCount} Date{summary.dateCount === 1 ? '' : 's'}</span>
                              <span className="compact-pill">{summary.schoolCount} School{summary.schoolCount === 1 ? '' : 's'}</span>
                              <span className="compact-pill">{summary.studentTotal} Students</span>
                            </div>

                            <div className="event-program-row-schedule">
                              <small>{rowDateSummary}</small>
                              <small>{`${summary.studentTotal} students, ${summary.teacherCount} teacher${summary.teacherCount === 1 ? '' : 's'}`}</small>
                            </div>

                            <div className="event-program-row-flags">
                              <span className={`event-access-badge ${eventProgram.student_performance ? 'public' : 'private'}`}>
                                {eventProgram.student_performance ? 'Student Performance' : 'Workshop'}
                              </span>
                              <span className="event-access-copy">
                                Admins enter school-level student counts and assigned teachers per date.
                              </span>
                            </div>

                            <div className="text-muted small event-program-expand">
                              {isOpen ? '▼ Collapse' : '▶ Expand'}
                            </div>
                          </div>
                        </td>
                      </tr>

                      {isOpen && (
                        <tr>
                          <td colSpan={1}>
                            <div className="event-program-detail-grid p-3 border rounded">
                              <div className="detail-panel">
                                <h6 className="mb-2">Overview</h6>
                                <div className="schedule-summary-row">
                                  <strong>Location</strong>
                                  <span>{getLocation(eventProgram.location_id)}</span>
                                </div>
                                <div className="schedule-summary-row">
                                  <strong>Student Performance</strong>
                                  <span>{eventProgram.student_performance ? 'Yes' : 'No'}</span>
                                </div>
                                <div className="mt-2 text-muted small">
                                  {eventProgram.description || 'No description provided.'}
                                </div>
                              </div>

                              <div className="detail-panel">
                                <h6 className="mb-2">Schedule Summary</h6>
                                <div className="schedule-summary-row">
                                  <strong>Dates</strong>
                                  <span>{summary.dateCount}</span>
                                </div>
                                <div className="schedule-summary-row">
                                  <strong>Next Date</strong>
                                  <span>{summary.nextDate}</span>
                                </div>
                                <div className="schedule-summary-row">
                                  <strong>Schools</strong>
                                  <span>{summary.schoolCount}</span>
                                </div>
                                <div className="schedule-summary-row">
                                  <strong>Tracked Attendance</strong>
                                  <span>{`${summary.studentTotal} students, ${summary.teacherCount} teachers`}</span>
                                </div>
                              </div>

                              <div className="detail-panel">
                                <h6 className="mb-2">Participants</h6>
                                <div className="schedule-summary-row">
                                  <strong>Schools</strong>
                                </div>
                                <ul className="mb-2">{getSchoolObj(eventProgram.event_id)}</ul>
                                <div className="schedule-summary-row">
                                  <strong>Teachers</strong>
                                </div>
                                {getTeachersForDate(eventProgram.event_id)}
                              </div>

                              <div className="detail-panel actions-panel">
                                <h6 className="mb-2">Actions</h6>
                                <Button type="button" onClick={() => editEventProgram(eventProgram)}>
                                  <i className="bi bi-pencil"></i> Edit Workshop
                                </Button>
                                <Button type="button" onClick={() => handleNewEventDate(eventProgram.event_id)}>
                                  New Date
                                </Button>
                                <Button type="button" variant="danger" onClick={() => deleteEventProgram(eventProgram.event_id)}>
                                  <i className="bi bi-trash3"></i> Delete Workshop
                                </Button>
                              </div>

                              <div className="detail-panel event-program-dates-detail">
                                <div className="schedule-panel-toolbar">
                                  <div>
                                    <div className="schedule-panel-title">Dates for {eventProgram.name}</div>
                                    <div className="schedule-panel-subtitle">
                                      Each date lists assigned teachers and per-school student counts.
                                    </div>
                                  </div>
                                  <Button type="button" onClick={() => handleNewEventDate(eventProgram.event_id)}>
                                    New Date
                                  </Button>
                                </div>
                                {renderEventDates(eventProgram)}
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
        <Modal size="lg" show={showEventDateModal} onHide={() => handleCancel()}>
          <Modal.Header>{currentEventDate.event_dates_id ? 'Edit Event Date' : 'Create New Event Date'}</Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Select Date</Form.Label>
                <Form.Control
                  type={'date'}
                  id='date'
                  name='date'
                  value={currentEventDate.date}
                  onChange={handleEventDateFormChange}>
                </Form.Control>
              </Form.Group>
              <Form.Group>
                <Form.Label>Start Time</Form.Label>
                <Form.Control
                  type={'time'}
                  id='start_time'
                  name='start_time'
                  value={currentEventDate.start_time}
                  onChange={handleEventDateFormChange}>
                </Form.Control>
              </Form.Group>
              <Form.Group>
                <Form.Label>End Time</Form.Label>
                <Form.Control
                  id='end_time'
                  value={currentEventDate.end_time}
                  type={'time'}
                  name='end_time'
                  onChange={handleEventDateFormChange}>
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="teacherId">
                <Form.Label>Teacher(s)</Form.Label>
                <Select
                  isMulti
                  isSearchable={true}
                  options={teacherProfiles.map(profile => ({ value: profile.profile_id, label: (`${profile.first_name} ${profile.last_name}`) }))}
                  value={selectedTeachers}
                  onChange={handleTeacherChange}
                  classNamePrefix="select"
                />
              </Form.Group>
              {dateSchools.map((ds, index) => (
                <Row key={index} className="mb-3 align-items-center">
                  <Col md={6}>
                    <Form.Group controlId={`school_${index}`}>
                      <Form.Label>School</Form.Label>
                      <Select
                        options={schoolOptions}
                        value={ds.school_id ? schoolOptions.find(s => s.value === ds.school_id) : null}
                        onChange={selectedOption => handleDateSchoolFormChange(index, 'school_id', selectedOption ? [selectedOption.value] : [])}
                        classNamePrefix="select"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group controlId={`number_of_students_${index}`}>
                      <Form.Label>Number of Students</Form.Label>
                      <Form.Control
                        type="number"
                        value={ds.number_of_students || ''}
                        onChange={e => handleDateSchoolFormChange(index, 'number_of_students', e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2} className="text-right">
                    {index > 0 && (
                      <Button variant="danger" onClick={() => handleMarkForDeletion(index)} className="mt-4">Remove</Button>
                    )}
                  </Col>
                </Row>
              ))}
              <Button variant="primary" onClick={addDateSchool}>Add Another School</Button>
            </Form>
            <Modal.Footer className='modal-footer-buttons'>
              {currentEventDate.event_dates_id ? 
              <Button variant='danger' onClick={() => handleDeleteEventDate()}>Delete</Button>
              : 
              ''}
              <Button onClick={handleEventDateSubmit}>{currentEventDate.event_dates_id ? 'Update' : 'Create'}</Button>
              <Button variant='secondary' onClick={() => handleCancel()}>Cancel</Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
        <Modal show={showDeletionError} onHide={() => setShowDeletionError(false)}>
          <Modal.Header>Unable to process Request</Modal.Header>
          <Modal.Body>Please be sure to delete all associated dates with the event before deleting the event</Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => setShowDeletionError(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)}>
          <Modal.Header closeButton>{'Please Confirm!'}</Modal.Header>
          <Modal.Body>{confirmationMessage}</Modal.Body>
          <Modal.Footer>
            <Button variant='danger' onClick={() => deleteEventDate(currentEventDate.event_dates_id)}>{'Delete'}</Button>
            <Button variant='secondary' onClick={() => setShowConfirmationModal(false)}>{'Cancel'}</Button>
          </Modal.Footer>
        </Modal>
        <ErrorModalMessage errorMessage={errorMessage} clearErrorMessage={() => setErrorMessage('')} />
      </div>
    );
};

export default WorkshopStudentsOBC;
